// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-banner[data-v-5e00ad4d] {\n  font-size: 13px;\n}\n.error-banner[data-v-5e00ad4d]:before {\n  background: #eb5757;\n}\n.launch-img[data-v-5e00ad4d] {\n  height: 60px;\n  vertical-align: middle;\n}", ""]);
// Exports
module.exports = exports;
